import React, { Component } from "react";
import postEvent, {
  createParkWebRedirectFosEvent,
} from "../commons/LanderEvent";
import { Settings } from "../config";

interface TargetedProps {
  targeted: {
    fosUrl: string;
    [key: string]: any;
  };
  queryConfig?: Record<string, any>;
}

export default class TargetedLander extends Component<TargetedProps> {
  componentDidMount() {
    const redirectEvent = createParkWebRedirectFosEvent(this.props.queryConfig);
    postEvent(Settings.EVENT_PUBLISH_API, redirectEvent);
  }

  render() {
    return (
      <iframe
        title="parked-content"
        width="100%"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          border: 0,
        }}
        src={ this.props.targeted.fosUrl }
      >
        Sorry your browser does not support inline frames.
      </iframe>
    );
  }
}
